import { IHistoryConstituent } from '../generated/graphql';

export const calculateDiscountPercent = (
  price: number,
  discount: number | null | undefined
): number => {
  if (discount) {
    return (discount / price) * 100;
  }
  return 0;
};

export const calculateVat = (
  price: number,
  discount: number | null | undefined,
  vatPercent: number | null | undefined
): number => {
  if (vatPercent) {
    const disc = discount ? discount : 0;
    return ((price - disc) * vatPercent) / 100;
  }
  return 0;
};

export const weightCalculation = (array: IHistoryConstituent[]) => {
  let sum = 0;
  array.map((hc) =>
    typeof Number(hc.weighting) === 'number' ? (sum += Number(hc.weighting)) : (sum += 0)
  );
  if (sum !== null) {
    return sum;
  } else {
    return 0;
  }
};

export const sumWeightPercentageCalculation = (array: IHistoryConstituent[]) => {
  let percentageSum = 0;
  array.map((hc) =>
    typeof Number(hc.weight_perc) === 'number'
      ? (percentageSum += Number(hc.weight_perc))
      : (percentageSum += 0)
  );
  if (percentageSum !== null) {
    return Number(percentageSum.toFixed(2));
  } else {
    return 0;
  }
};

export const normalizePercentInput = (input: number): number => {
  let result = input;
  if (input < 0) result = 0;
  if (input > 100) result = 100;
  return Number(result.toFixed(2));
};

type genericObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const objectsAreEquel = (
  obj1: genericObject | null,
  obj2: genericObject | null
): boolean => {
  if (obj1 === obj2) {
    return true;
  }
  if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }

  for (const key of obj1Keys) {
    if (!obj2Keys.includes(key)) {
      return false;
    }
    if (typeof obj1[key] === 'object') {
      if (!objectsAreEquel(obj1[key], obj2[key])) {
        return false;
      }
    } else if (typeof obj1[key] !== typeof obj2[key] || obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};

export const calculateMeetingDuration = (startTime: string, endTime: string) => {
  const startDate = parseDate(startTime);
  const endDate = parseDate(endTime);

  if (startDate && endDate) {
    // Calculate the time difference in milliseconds
    const timeDifference = endDate.getTime() - startDate.getTime();

    // Convert milliseconds to HH:MM format
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    // Format the result
    const formattedDuration = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )}`;
    return formattedDuration;
  }

  return 'Invalid date format';
};

const parseDate = (dateTime: string) => {
  const [day, month, year, hour, minute] = dateTime.match(/\d+/g)?.map(Number) || [];
  if (day && month && year && hour !== undefined && minute !== undefined) {
    return new Date(year, month - 1, day, hour, minute);
  }
  return null;
};

export const numberWithCommas = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
